export class BFAnimatedSprite extends PIXI.AnimatedSprite {
  constructor(texture: PIXI.FrameObject[]) {
    super(texture);

    this.duration = this._durations.reduce(
      (tot: number, duration: number) => tot + duration,
      0
    );
  }
  gotoAndStop(frameNumberOrTime: number, isTime?: boolean): void {
    if (!isTime || !this._durations) {
      super.gotoAndStop(frameNumberOrTime);
      return;
    }
    const time = (frameNumberOrTime * 1000) % this.duration;
    const frame = Math.floor((time / this.duration) * this._durations.length);
    super.gotoAndStop(frame);
  }
}



// WEBPACK FOOTER //
// ./src/utils/BFAnimatedSprite.ts